import { takeEvery, put, call, all } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { patInqActionTypes } from '../actions/patInqActionTypes';
import { exportErrorMsg, processError, renderFileName } from '../../../../common/util';
import invokeApi from '../../../../common/apiManagement/invokeApi';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import {
  processingStarted,
  processingCompleted,
} from '../../../../common/redux/actions/commonActions';
import moduleAPI from '../../config/apiConfig';
import { globalConstants } from '../../../../common/moduleConstants';

// task inquiry
export function* getProducerAuditTrailExportList(action) {
  yield all([
    put(processingStarted()),
    put(getAction(patInqActionTypes.RESET_SERVER_VALUE_PATINQ, null)),
  ]);
  let resetServerValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.PAT_INQUIRY_EXPORT,
      action.data,
    );
    const filename = renderFileName(responseData);
    const urlData = window.URL.createObjectURL(new Blob([responseData.data]));
    FileSaver(urlData, filename);
    yield put(processingCompleted());
  } catch (err) {
    if (err.response.status === globalConstants.errorCode402 || err.response.status === globalConstants.errorCode403) {
      const errorObject = exportErrorMsg(err.response.status);
      resetServerValue = { serverRequestError: errorObject };
    } else {
      resetServerValue = { serverRequestError: processError(err) };
    }
    yield all([
      put(getAction(patInqActionTypes.RESET_SERVER_VALUE_PATINQ, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
}

export function* getProducerAuditTrailList(action) {
  yield all([
    put(processingStarted()),
    put(getAction(patInqActionTypes.RESET_SERVER_VALUE_PATINQ, null)),
    put(getAction(patInqActionTypes.LOG_PATINQ_LIST_REQUEST, action.data)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.PAT_INQUIRY_LIST, action.data);
    yield all([
      put(getAction(patInqActionTypes.GET_PATINQ_LIST_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(patInqActionTypes.RESET_SERVER_VALUE_PATINQ, resetServerValue)),
      put(getAction(patInqActionTypes.GET_PATINQ_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
}
function* producerAuditTrailWatcher() {
  yield takeEvery(patInqActionTypes.GET_PATINQ_LIST_REQUEST, getProducerAuditTrailList);
  yield takeEvery(patInqActionTypes.GET_PATINQ_EXPORT_REQUEST, getProducerAuditTrailExportList);
}

export default producerAuditTrailWatcher;
